<template>
    <div class="btn-group ">
        <div class="btn-group ">
            <button 
                type="button" 
                class="btn dropdown-toggle btn-flat bg-" 
                v-bind:class="cssCustom"
                data-toggle="dropdown">
                {{titleCustom}}
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item" href="#" v-on:click="changeItems(15)"> 15 <i v-if="itemsCurrent=== 15"  class="fa fa-arrow-left text-primary"></i></a>
                <a class="dropdown-item" href="#" v-on:click="changeItems(25)"> 25 <i v-if="itemsCurrent=== 25"  class="fa fa-arrow-left text-primary"></i></a>
                <a class="dropdown-item" href="#" v-on:click="changeItems(50)"> 50 <i v-if="itemsCurrent=== 50"  class="fa fa-arrow-left text-primary"></i></a>
                <a class="dropdown-item" href="#" v-on:click="changeItems(75)"> 75 <i v-if="itemsCurrent=== 75"  class="fa fa-arrow-left text-primary"></i></a>
                <a class="dropdown-item" href="#" v-on:click="changeItems(100)">100<i v-if="itemsCurrent=== 100" class="fa fa-arrow-left text-primary"></i></a>
                <a class="dropdown-item" href="#" v-on:click="changeItems(150)">150<i v-if="itemsCurrent=== 150" class="fa fa-arrow-left text-primary"></i></a>
                <a class="dropdown-item" href="#" v-on:click="changeItems(120)">200<i v-if="itemsCurrent=== 200" class="fa fa-arrow-left text-primary"></i></a>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    defineProps<{
        cssCustom:string,                        
        itemsCurrent: number,
        titleCustom:string
    } > ()
    
    const emit = defineEmits<{ (e: 'totalItems',items:number): void }>()
            
    const changeItems = (items: number) => { emit('totalItems',items ); }
</script>